import { type Meta } from '../types/docs';
import { SKILL_ANALYTICS_SCOPES, SKILL_ANALYTICS_TYPES } from './skillAnalytics';

const META: Meta = {
  description: 'Fired when a user successfully updates an existing skill',
  name: 'skill_updated',
  params: [
    {
      description: 'ID of the updated skill',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Current scope after update',
      name: 'scope',
      required: true,
      type: 'enum',
      values: [...SKILL_ANALYTICS_SCOPES],
    },
    {
      description: 'Skill surface',
      name: 'type',
      required: true,
      type: 'enum',
      values: [...SKILL_ANALYTICS_TYPES],
    },
  ],
};

export default META;
